import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useDispatch, useSelector } from '../../../../../store/store';
import { LeaveMemberIcon, LeaveSquareIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import { leaveOrganizationThunk } from '../../../../../store/workspace/thunks';
import { useState } from 'react';
import { setConfirmLeaveOrganizationModal } from '../../../../../store/workspace/slice';
import { selectUserId } from '../../../../../store/auth/selectors';

export default function ConfirmLeaveOrganization() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const [isLoading, setIsLoading] = useState(false);

    const next = () => {
        if (!userId) return;

        setIsLoading(true);
        dispatch(leaveOrganizationThunk({ action: 'leave' }))
            .unwrap()
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                setIsLoading(false);
            })
    };

    return (
        <Modal
            size='sm'
            title='Leave organization'
            icon={<LeaveSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setConfirmLeaveOrganizationModal(false))}
        >
            <LeaveMemberIcon />
            <span className={styles.text}>
                Are you sure you want to leave the organization's account membership?
            </span>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setConfirmLeaveOrganizationModal(false))}
                />
                <Button
                    type='Error'
                    text='Leave organization'
                    loading={isLoading}
                    onClick={next}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
